"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/account.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Faccount.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.cryptoAccountOriginGraduationGraduationStatusToJSON = exports.cryptoAccountOriginGraduationGraduationStatusFromJSON = exports.installmentLoanStatusToJSON = exports.installmentLoanStatusFromJSON = exports.installmentLoanPaymentScheduleToJSON = exports.installmentLoanPaymentScheduleFromJSON = exports.accountTypeToJSON = exports.accountTypeFromJSON = exports.subAccountFilterToJSON = exports.subAccountFilterFromJSON = exports.accountClosabilityToJSON = exports.accountClosabilityFromJSON = exports.accountAccessLevelToJSON = exports.accountAccessLevelFromJSON = exports.unsecuredCreditAutoPayTypeToJSON = exports.unsecuredCreditAutoPayTypeFromJSON = exports.AccountPermissionGroup = exports.AccountPermission = exports.Crypto = exports.CryptoAccountOwnershipChange = exports.CryptoAccountTransferGraduation = exports.CryptoAccountTransfer = exports.CryptoAccountOriginGraduation = exports.CryptoAccountOrigin = exports.InstallmentLoanInstallment = exports.InstallmentLoanBorrowCash = exports.InstallmentLoanPurchase = exports.InstallmentLoan = exports.SavingsMatching = exports.Savings = exports.Points = exports.CashAdvance = exports.UnsecuredCreditAutoPay = exports.UnsecuredCredit = exports.Credit = exports.OverdraftProtection = exports.Deposit = exports.SubAccountContext = exports.AccountSubAccount = exports.Account = exports.CryptoAccountOriginGraduationGraduationStatus = exports.InstallmentLoanStatus = exports.InstallmentLoanPaymentSchedule = exports.AccountType = exports.SubAccountFilter = exports.AccountClosability = exports.AccountAccessLevel = exports.UnsecuredCreditAutoPayType = void 0;
const ach_account_1 = require("../common/ach-account");
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const family_group_1 = require("../common/family-group");
const primary_account_type_1 = require("../common/primary-account-type");
const transaction_1 = require("../ledger/transaction");
const image_1 = require("./image");
const protobufPackage = 'com.step.account.proto';
var UnsecuredCreditAutoPayType;
(function (UnsecuredCreditAutoPayType) {
    UnsecuredCreditAutoPayType["INVALID_AUTO_PAY_TYPE"] = "INVALID_AUTO_PAY_TYPE";
    UnsecuredCreditAutoPayType["PAY_MINIMUM_BALANCE"] = "PAY_MINIMUM_BALANCE";
    UnsecuredCreditAutoPayType["PAY_STATEMENT_BALANCE"] = "PAY_STATEMENT_BALANCE";
    UnsecuredCreditAutoPayType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(UnsecuredCreditAutoPayType || (exports.UnsecuredCreditAutoPayType = UnsecuredCreditAutoPayType = {}));
/**
 * Account access level.
 *
 * Sorted in the escalating access order!
 */
var AccountAccessLevel;
(function (AccountAccessLevel) {
    AccountAccessLevel["INVALID"] = "INVALID";
    AccountAccessLevel["RESTRICTED"] = "RESTRICTED";
    AccountAccessLevel["FULL"] = "FULL";
    AccountAccessLevel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountAccessLevel || (exports.AccountAccessLevel = AccountAccessLevel = {}));
/**
 * Whether an account can be closed.
 */
var AccountClosability;
(function (AccountClosability) {
    AccountClosability["INVALID_ACCOUNT_CLOSABILITY"] = "INVALID_ACCOUNT_CLOSABILITY";
    AccountClosability["CLOSABLE"] = "CLOSABLE";
    AccountClosability["BALANCE_NOT_ZERO"] = "BALANCE_NOT_ZERO";
    AccountClosability["PENDING_TRANSACTION"] = "PENDING_TRANSACTION";
    AccountClosability["PENDING_CARD_AUTH"] = "PENDING_CARD_AUTH";
    AccountClosability["PENDING_TRANSFER_HOLD"] = "PENDING_TRANSFER_HOLD";
    AccountClosability["UNRESOLVED_DISPUTE"] = "UNRESOLVED_DISPUTE";
    AccountClosability["DEPENDENT_ACCOUNT"] = "DEPENDENT_ACCOUNT";
    AccountClosability["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountClosability || (exports.AccountClosability = AccountClosability = {}));
var SubAccountFilter;
(function (SubAccountFilter) {
    SubAccountFilter["INVALID_SUB_ACCOUNT_FILTER"] = "INVALID_SUB_ACCOUNT_FILTER";
    SubAccountFilter["ONLY_OPEN"] = "ONLY_OPEN";
    SubAccountFilter["ONLY_CLOSED"] = "ONLY_CLOSED";
    SubAccountFilter["ALL"] = "ALL";
    SubAccountFilter["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SubAccountFilter || (exports.SubAccountFilter = SubAccountFilter = {}));
var AccountType;
(function (AccountType) {
    AccountType["INVALID_ACCOUNT_TYPE"] = "INVALID_ACCOUNT_TYPE";
    AccountType["DEPOSIT"] = "DEPOSIT";
    AccountType["SAVINGS"] = "SAVINGS";
    AccountType["CREDIT"] = "CREDIT";
    AccountType["INSTALLMENT_LOAN"] = "INSTALLMENT_LOAN";
    AccountType["CRYPTO"] = "CRYPTO";
    AccountType["UNSECURED_CREDIT"] = "UNSECURED_CREDIT";
    AccountType["CASH_ADVANCE"] = "CASH_ADVANCE";
    AccountType["POINTS"] = "POINTS";
    AccountType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AccountType || (exports.AccountType = AccountType = {}));
var InstallmentLoanPaymentSchedule;
(function (InstallmentLoanPaymentSchedule) {
    InstallmentLoanPaymentSchedule["SCHEDULE_NOT_SET"] = "SCHEDULE_NOT_SET";
    /**
     * BI_WEEKLY - Every 14d, default schedule
     */
    InstallmentLoanPaymentSchedule["BI_WEEKLY"] = "BI_WEEKLY";
    /**
     * ESTIMATED - Based on estimated DD dates
     */
    InstallmentLoanPaymentSchedule["ESTIMATED"] = "ESTIMATED";
    InstallmentLoanPaymentSchedule["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstallmentLoanPaymentSchedule || (exports.InstallmentLoanPaymentSchedule = InstallmentLoanPaymentSchedule = {}));
var InstallmentLoanStatus;
(function (InstallmentLoanStatus) {
    InstallmentLoanStatus["INVALID_INSTALLMENT_LOAN_STATUS"] = "INVALID_INSTALLMENT_LOAN_STATUS";
    /**
     * PENDING - The installment is not due yet.
     */
    InstallmentLoanStatus["PENDING"] = "PENDING";
    /**
     * PAID - The installment has been paid.
     */
    InstallmentLoanStatus["PAID"] = "PAID";
    /**
     * DUE - The installment is due, but within grace period.
     */
    InstallmentLoanStatus["DUE"] = "DUE";
    /**
     * PAST_DUE - The installment is past due.
     */
    InstallmentLoanStatus["PAST_DUE"] = "PAST_DUE";
    InstallmentLoanStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InstallmentLoanStatus || (exports.InstallmentLoanStatus = InstallmentLoanStatus = {}));
var CryptoAccountOriginGraduationGraduationStatus;
(function (CryptoAccountOriginGraduationGraduationStatus) {
    CryptoAccountOriginGraduationGraduationStatus["INVALID_GRADUATION_STATUS"] = "INVALID_GRADUATION_STATUS";
    CryptoAccountOriginGraduationGraduationStatus["PENDING"] = "PENDING";
    CryptoAccountOriginGraduationGraduationStatus["COMPLETED"] = "COMPLETED";
    CryptoAccountOriginGraduationGraduationStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CryptoAccountOriginGraduationGraduationStatus || (exports.CryptoAccountOriginGraduationGraduationStatus = CryptoAccountOriginGraduationGraduationStatus = {}));
function createBaseAccount() {
    return {
        primaryId: '',
        accountNumber: '',
        subAccounts: [],
        currency: '',
        ownerUserId: '',
        authorizedUserId: '',
        permissions: [],
        shard: 0,
        openedAtMs: '0',
        closedAtMs: '0',
        achAccount: undefined,
        billingDay: 0,
        type: primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE,
        updatedAtMs: '0',
    };
}
exports.Account = {
    fromJSON(object) {
        const message = {
            primaryId: isSet(object.primaryId) ? globalThis.String(object.primaryId) : '',
            subAccounts: globalThis.Array.isArray(object?.subAccounts)
                ? object.subAccounts.map((e) => exports.AccountSubAccount.fromJSON(e))
                : [],
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
            ownerUserId: isSet(object.ownerUserId) ? globalThis.String(object.ownerUserId) : '',
            permissions: globalThis.Array.isArray(object?.permissions)
                ? object.permissions.map((e) => exports.AccountPermission.fromJSON(e))
                : [],
            openedAtMs: isSet(object.openedAtMs) ? globalThis.String(object.openedAtMs) : '0',
        };
        if (isSet(object.accountNumber)) {
            message.accountNumber = globalThis.String(object.accountNumber);
        }
        if (isSet(object.authorizedUserId)) {
            message.authorizedUserId = globalThis.String(object.authorizedUserId);
        }
        if (isSet(object.shard)) {
            message.shard = globalThis.Number(object.shard);
        }
        if (isSet(object.closedAtMs)) {
            message.closedAtMs = globalThis.String(object.closedAtMs);
        }
        if (isSet(object.achAccount)) {
            message.achAccount = ach_account_1.AchAccount.fromJSON(object.achAccount);
        }
        if (isSet(object.billingDay)) {
            message.billingDay = globalThis.Number(object.billingDay);
        }
        if (isSet(object.type)) {
            message.type = (0, primary_account_type_1.primaryAccountTypeFromJSON)(object.type);
        }
        if (isSet(object.updatedAtMs)) {
            message.updatedAtMs = globalThis.String(object.updatedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryId !== '') {
            obj.primaryId = message.primaryId;
        }
        if (message.accountNumber !== undefined && message.accountNumber !== '') {
            obj.accountNumber = message.accountNumber;
        }
        if (message.subAccounts?.length) {
            obj.subAccounts = message.subAccounts.map((e) => exports.AccountSubAccount.toJSON(e));
        }
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.ownerUserId !== '') {
            obj.ownerUserId = message.ownerUserId;
        }
        if (message.authorizedUserId !== undefined && message.authorizedUserId !== '') {
            obj.authorizedUserId = message.authorizedUserId;
        }
        if (message.permissions?.length) {
            obj.permissions = message.permissions.map((e) => exports.AccountPermission.toJSON(e));
        }
        if (message.shard !== undefined && message.shard !== 0) {
            obj.shard = Math.round(message.shard);
        }
        if (message.openedAtMs !== '0') {
            obj.openedAtMs = message.openedAtMs;
        }
        if (message.closedAtMs !== undefined && message.closedAtMs !== '0') {
            obj.closedAtMs = message.closedAtMs;
        }
        if (message.achAccount !== undefined) {
            obj.achAccount = ach_account_1.AchAccount.toJSON(message.achAccount);
        }
        if (message.billingDay !== undefined && message.billingDay !== 0) {
            obj.billingDay = Math.round(message.billingDay);
        }
        if (message.type !== undefined && message.type !== primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE) {
            obj.type = (0, primary_account_type_1.primaryAccountTypeToJSON)(message.type);
        }
        if (message.updatedAtMs !== undefined && message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.Account.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccount();
        message.primaryId = object.primaryId ?? '';
        message.accountNumber = object.accountNumber ?? '';
        message.subAccounts = object.subAccounts?.map((e) => exports.AccountSubAccount.fromPartial(e)) || [];
        message.currency = object.currency ?? '';
        message.ownerUserId = object.ownerUserId ?? '';
        message.authorizedUserId = object.authorizedUserId ?? '';
        message.permissions = object.permissions?.map((e) => exports.AccountPermission.fromPartial(e)) || [];
        message.shard = object.shard ?? 0;
        message.openedAtMs = object.openedAtMs ?? '0';
        message.closedAtMs = object.closedAtMs ?? '0';
        message.achAccount = (object.achAccount !== undefined && object.achAccount !== null)
            ? ach_account_1.AchAccount.fromPartial(object.achAccount)
            : undefined;
        message.billingDay = object.billingDay ?? 0;
        message.type = object.type ?? primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE;
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseAccountSubAccount() {
    return {
        id: '',
        type: AccountType.INVALID_ACCOUNT_TYPE,
        context: exports.SubAccountContext.fromPartial({}),
        createdAtMs: '0',
        updatedAtMs: '0',
        closedAtMs: '0',
    };
}
exports.AccountSubAccount = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            context: isSet(object.context)
                ? exports.SubAccountContext.fromJSON(object.context)
                : exports.SubAccountContext.fromPartial({}),
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.type)) {
            message.type = accountTypeFromJSON(object.type);
        }
        if (isSet(object.closedAtMs)) {
            message.closedAtMs = globalThis.String(object.closedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.type !== undefined && message.type !== AccountType.INVALID_ACCOUNT_TYPE) {
            obj.type = accountTypeToJSON(message.type);
        }
        if (message.context !== undefined) {
            obj.context = exports.SubAccountContext.toJSON(message.context);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.closedAtMs !== undefined && message.closedAtMs !== '0') {
            obj.closedAtMs = message.closedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.AccountSubAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountSubAccount();
        message.id = object.id ?? '';
        message.type = object.type ?? AccountType.INVALID_ACCOUNT_TYPE;
        message.context = (object.context !== undefined && object.context !== null)
            ? exports.SubAccountContext.fromPartial(object.context)
            : exports.SubAccountContext.fromPartial({});
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.closedAtMs = object.closedAtMs ?? '0';
        return message;
    },
};
function createBaseSubAccountContext() {
    return {
        deposit: undefined,
        credit: undefined,
        savings: undefined,
        installment: undefined,
        crypto: undefined,
        unsecuredCredit: undefined,
        cashAdvance: undefined,
        points: undefined,
    };
}
exports.SubAccountContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.deposit)) {
            message.deposit = exports.Deposit.fromJSON(object.deposit);
        }
        if (isSet(object.credit)) {
            message.credit = exports.Credit.fromJSON(object.credit);
        }
        if (isSet(object.savings)) {
            message.savings = exports.Savings.fromJSON(object.savings);
        }
        if (isSet(object.installment)) {
            message.installment = exports.InstallmentLoan.fromJSON(object.installment);
        }
        if (isSet(object.crypto)) {
            message.crypto = exports.Crypto.fromJSON(object.crypto);
        }
        if (isSet(object.unsecuredCredit)) {
            message.unsecuredCredit = exports.UnsecuredCredit.fromJSON(object.unsecuredCredit);
        }
        if (isSet(object.cashAdvance)) {
            message.cashAdvance = exports.CashAdvance.fromJSON(object.cashAdvance);
        }
        if (isSet(object.points)) {
            message.points = exports.Points.fromJSON(object.points);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.deposit !== undefined) {
            obj.deposit = exports.Deposit.toJSON(message.deposit);
        }
        if (message.credit !== undefined) {
            obj.credit = exports.Credit.toJSON(message.credit);
        }
        if (message.savings !== undefined) {
            obj.savings = exports.Savings.toJSON(message.savings);
        }
        if (message.installment !== undefined) {
            obj.installment = exports.InstallmentLoan.toJSON(message.installment);
        }
        if (message.crypto !== undefined) {
            obj.crypto = exports.Crypto.toJSON(message.crypto);
        }
        if (message.unsecuredCredit !== undefined) {
            obj.unsecuredCredit = exports.UnsecuredCredit.toJSON(message.unsecuredCredit);
        }
        if (message.cashAdvance !== undefined) {
            obj.cashAdvance = exports.CashAdvance.toJSON(message.cashAdvance);
        }
        if (message.points !== undefined) {
            obj.points = exports.Points.toJSON(message.points);
        }
        return obj;
    },
    create(base) {
        return exports.SubAccountContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubAccountContext();
        message.deposit = (object.deposit !== undefined && object.deposit !== null)
            ? exports.Deposit.fromPartial(object.deposit)
            : undefined;
        message.credit = (object.credit !== undefined && object.credit !== null)
            ? exports.Credit.fromPartial(object.credit)
            : undefined;
        message.savings = (object.savings !== undefined && object.savings !== null)
            ? exports.Savings.fromPartial(object.savings)
            : undefined;
        message.installment = (object.installment !== undefined && object.installment !== null)
            ? exports.InstallmentLoan.fromPartial(object.installment)
            : undefined;
        message.crypto = (object.crypto !== undefined && object.crypto !== null)
            ? exports.Crypto.fromPartial(object.crypto)
            : undefined;
        message.unsecuredCredit =
            (object.unsecuredCredit !== undefined && object.unsecuredCredit !== null)
                ? exports.UnsecuredCredit.fromPartial(object.unsecuredCredit)
                : undefined;
        message.cashAdvance = (object.cashAdvance !== undefined && object.cashAdvance !== null)
            ? exports.CashAdvance.fromPartial(object.cashAdvance)
            : undefined;
        message.points = (object.points !== undefined && object.points !== null)
            ? exports.Points.fromPartial(object.points)
            : undefined;
        return message;
    },
};
function createBaseDeposit() {
    return { overdraftProtection: undefined };
}
exports.Deposit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.overdraftProtection)) {
            message.overdraftProtection = exports.OverdraftProtection.fromJSON(object.overdraftProtection);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.overdraftProtection !== undefined) {
            obj.overdraftProtection = exports.OverdraftProtection.toJSON(message.overdraftProtection);
        }
        return obj;
    },
    create(base) {
        return exports.Deposit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeposit();
        message.overdraftProtection =
            (object.overdraftProtection !== undefined && object.overdraftProtection !== null)
                ? exports.OverdraftProtection.fromPartial(object.overdraftProtection)
                : undefined;
        return message;
    },
};
function createBaseOverdraftProtection() {
    return { amount: amount_1.Amount.fromPartial({}), enabled: false };
}
exports.OverdraftProtection = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.OverdraftProtection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOverdraftProtection();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseCredit() {
    return { allowForeignCharges: false };
}
exports.Credit = {
    fromJSON(object) {
        const message = {
            allowForeignCharges: isSet(object.allowForeignCharges)
                ? globalThis.Boolean(object.allowForeignCharges)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.allowForeignCharges !== false) {
            obj.allowForeignCharges = message.allowForeignCharges;
        }
        return obj;
    },
    create(base) {
        return exports.Credit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCredit();
        message.allowForeignCharges = object.allowForeignCharges ?? false;
        return message;
    },
};
function createBaseUnsecuredCredit() {
    return {
        active: false,
        minBalance: amount_1.Amount.fromPartial({}),
        rolloverEnabled: false,
        autoPay: exports.UnsecuredCreditAutoPay.fromPartial({}),
        isInterestFree: false,
        creditLimit: undefined,
        selectedCreditLimit: undefined,
    };
}
exports.UnsecuredCredit = {
    fromJSON(object) {
        const message = {
            active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
            minBalance: isSet(object.minBalance)
                ? amount_1.Amount.fromJSON(object.minBalance)
                : amount_1.Amount.fromPartial({}),
            rolloverEnabled: isSet(object.rolloverEnabled)
                ? globalThis.Boolean(object.rolloverEnabled)
                : false,
            autoPay: isSet(object.autoPay)
                ? exports.UnsecuredCreditAutoPay.fromJSON(object.autoPay)
                : exports.UnsecuredCreditAutoPay.fromPartial({}),
            isInterestFree: isSet(object.isInterestFree)
                ? globalThis.Boolean(object.isInterestFree)
                : false,
        };
        if (isSet(object.creditLimit)) {
            message.creditLimit = amount_1.Amount.fromJSON(object.creditLimit);
        }
        if (isSet(object.selectedCreditLimit)) {
            message.selectedCreditLimit = amount_1.Amount.fromJSON(object.selectedCreditLimit);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.active !== false) {
            obj.active = message.active;
        }
        if (message.minBalance !== undefined) {
            obj.minBalance = amount_1.Amount.toJSON(message.minBalance);
        }
        if (message.rolloverEnabled !== false) {
            obj.rolloverEnabled = message.rolloverEnabled;
        }
        if (message.autoPay !== undefined) {
            obj.autoPay = exports.UnsecuredCreditAutoPay.toJSON(message.autoPay);
        }
        if (message.isInterestFree !== false) {
            obj.isInterestFree = message.isInterestFree;
        }
        if (message.creditLimit !== undefined) {
            obj.creditLimit = amount_1.Amount.toJSON(message.creditLimit);
        }
        if (message.selectedCreditLimit !== undefined) {
            obj.selectedCreditLimit = amount_1.Amount.toJSON(message.selectedCreditLimit);
        }
        return obj;
    },
    create(base) {
        return exports.UnsecuredCredit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnsecuredCredit();
        message.active = object.active ?? false;
        message.minBalance = (object.minBalance !== undefined && object.minBalance !== null)
            ? amount_1.Amount.fromPartial(object.minBalance)
            : amount_1.Amount.fromPartial({});
        message.rolloverEnabled = object.rolloverEnabled ?? false;
        message.autoPay = (object.autoPay !== undefined && object.autoPay !== null)
            ? exports.UnsecuredCreditAutoPay.fromPartial(object.autoPay)
            : exports.UnsecuredCreditAutoPay.fromPartial({});
        message.isInterestFree = object.isInterestFree ?? false;
        message.creditLimit = (object.creditLimit !== undefined && object.creditLimit !== null)
            ? amount_1.Amount.fromPartial(object.creditLimit)
            : undefined;
        message.selectedCreditLimit =
            (object.selectedCreditLimit !== undefined && object.selectedCreditLimit !== null)
                ? amount_1.Amount.fromPartial(object.selectedCreditLimit)
                : undefined;
        return message;
    },
};
function createBaseUnsecuredCreditAutoPay() {
    return { enabled: false, type: UnsecuredCreditAutoPayType.INVALID_AUTO_PAY_TYPE };
}
exports.UnsecuredCreditAutoPay = {
    fromJSON(object) {
        const message = {
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
            type: isSet(object.type)
                ? unsecuredCreditAutoPayTypeFromJSON(object.type)
                : UnsecuredCreditAutoPayType.INVALID_AUTO_PAY_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        if (message.type !== UnsecuredCreditAutoPayType.INVALID_AUTO_PAY_TYPE) {
            obj.type = unsecuredCreditAutoPayTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.UnsecuredCreditAutoPay.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnsecuredCreditAutoPay();
        message.enabled = object.enabled ?? false;
        message.type = object.type ?? UnsecuredCreditAutoPayType.INVALID_AUTO_PAY_TYPE;
        return message;
    },
};
function createBaseCashAdvance() {
    return {};
}
exports.CashAdvance = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CashAdvance.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCashAdvance();
        return message;
    },
};
function createBasePoints() {
    return {};
}
exports.Points = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.Points.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePoints();
        return message;
    },
};
function createBaseSavings() {
    return {
        title: '',
        iconImage: image_1.Image.fromPartial({}),
        coverImage: image_1.Image.fromPartial({}),
        goal: undefined,
        roundUp: false,
        piggyBank: false,
        matching: [],
    };
}
exports.Savings = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            iconImage: isSet(object.iconImage) ? image_1.Image.fromJSON(object.iconImage) : image_1.Image.fromPartial({}),
            coverImage: isSet(object.coverImage)
                ? image_1.Image.fromJSON(object.coverImage)
                : image_1.Image.fromPartial({}),
        };
        if (isSet(object.goal)) {
            message.goal = amount_1.Amount.fromJSON(object.goal);
        }
        if (isSet(object.roundUp)) {
            message.roundUp = globalThis.Boolean(object.roundUp);
        }
        if (isSet(object.piggyBank)) {
            message.piggyBank = globalThis.Boolean(object.piggyBank);
        }
        if (globalThis.Array.isArray(object?.matching)) {
            message.matching = object.matching.map((e) => exports.SavingsMatching.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.iconImage !== undefined) {
            obj.iconImage = image_1.Image.toJSON(message.iconImage);
        }
        if (message.coverImage !== undefined) {
            obj.coverImage = image_1.Image.toJSON(message.coverImage);
        }
        if (message.goal !== undefined) {
            obj.goal = amount_1.Amount.toJSON(message.goal);
        }
        if (message.roundUp !== undefined && message.roundUp !== false) {
            obj.roundUp = message.roundUp;
        }
        if (message.piggyBank !== undefined && message.piggyBank !== false) {
            obj.piggyBank = message.piggyBank;
        }
        if (message.matching?.length) {
            obj.matching = message.matching.map((e) => exports.SavingsMatching.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Savings.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavings();
        message.title = object.title ?? '';
        message.iconImage = (object.iconImage !== undefined && object.iconImage !== null)
            ? image_1.Image.fromPartial(object.iconImage)
            : image_1.Image.fromPartial({});
        message.coverImage = (object.coverImage !== undefined && object.coverImage !== null)
            ? image_1.Image.fromPartial(object.coverImage)
            : image_1.Image.fromPartial({});
        message.goal = (object.goal !== undefined && object.goal !== null)
            ? amount_1.Amount.fromPartial(object.goal)
            : undefined;
        message.roundUp = object.roundUp ?? false;
        message.piggyBank = object.piggyBank ?? false;
        message.matching = object.matching?.map((e) => exports.SavingsMatching.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSavingsMatching() {
    return { sourceAccountId: '', userId: '', enabledAtMs: '0' };
}
exports.SavingsMatching = {
    fromJSON(object) {
        const message = {
            sourceAccountId: isSet(object.sourceAccountId)
                ? globalThis.String(object.sourceAccountId)
                : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.enabledAtMs)) {
            message.enabledAtMs = globalThis.String(object.enabledAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sourceAccountId !== '') {
            obj.sourceAccountId = message.sourceAccountId;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.enabledAtMs !== undefined && message.enabledAtMs !== '0') {
            obj.enabledAtMs = message.enabledAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.SavingsMatching.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsMatching();
        message.sourceAccountId = object.sourceAccountId ?? '';
        message.userId = object.userId ?? '';
        message.enabledAtMs = object.enabledAtMs ?? '0';
        return message;
    },
};
function createBaseInstallmentLoan() {
    return {
        purchasePaymentId: '',
        installments: [],
        loanName: '',
        apr: '',
        purchase: undefined,
        cash: undefined,
        autoPay: false,
        paymentSchedule: InstallmentLoanPaymentSchedule.SCHEDULE_NOT_SET,
    };
}
exports.InstallmentLoan = {
    fromJSON(object) {
        const message = {
            installments: globalThis.Array.isArray(object?.installments)
                ? object.installments.map((e) => exports.InstallmentLoanInstallment.fromJSON(e))
                : [],
            autoPay: isSet(object.autoPay) ? globalThis.Boolean(object.autoPay) : false,
        };
        if (isSet(object.purchasePaymentId)) {
            message.purchasePaymentId = globalThis.String(object.purchasePaymentId);
        }
        if (isSet(object.loanName)) {
            message.loanName = globalThis.String(object.loanName);
        }
        if (isSet(object.apr)) {
            message.apr = globalThis.String(object.apr);
        }
        if (isSet(object.purchase)) {
            message.purchase = exports.InstallmentLoanPurchase.fromJSON(object.purchase);
        }
        if (isSet(object.cash)) {
            message.cash = exports.InstallmentLoanBorrowCash.fromJSON(object.cash);
        }
        if (isSet(object.paymentSchedule)) {
            message.paymentSchedule = installmentLoanPaymentScheduleFromJSON(object.paymentSchedule);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchasePaymentId !== undefined && message.purchasePaymentId !== '') {
            obj.purchasePaymentId = message.purchasePaymentId;
        }
        if (message.installments?.length) {
            obj.installments = message.installments.map((e) => exports.InstallmentLoanInstallment.toJSON(e));
        }
        if (message.loanName !== undefined && message.loanName !== '') {
            obj.loanName = message.loanName;
        }
        if (message.apr !== undefined && message.apr !== '') {
            obj.apr = message.apr;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.InstallmentLoanPurchase.toJSON(message.purchase);
        }
        if (message.cash !== undefined) {
            obj.cash = exports.InstallmentLoanBorrowCash.toJSON(message.cash);
        }
        if (message.autoPay !== false) {
            obj.autoPay = message.autoPay;
        }
        if (message.paymentSchedule !== undefined &&
            message.paymentSchedule !== InstallmentLoanPaymentSchedule.SCHEDULE_NOT_SET) {
            obj.paymentSchedule = installmentLoanPaymentScheduleToJSON(message.paymentSchedule);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoan.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoan();
        message.purchasePaymentId = object.purchasePaymentId ?? '';
        message.installments =
            object.installments?.map((e) => exports.InstallmentLoanInstallment.fromPartial(e)) || [];
        message.loanName = object.loanName ?? '';
        message.apr = object.apr ?? '';
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.InstallmentLoanPurchase.fromPartial(object.purchase)
            : undefined;
        message.cash = (object.cash !== undefined && object.cash !== null)
            ? exports.InstallmentLoanBorrowCash.fromPartial(object.cash)
            : undefined;
        message.autoPay = object.autoPay ?? false;
        message.paymentSchedule = object.paymentSchedule ??
            InstallmentLoanPaymentSchedule.SCHEDULE_NOT_SET;
        return message;
    },
};
function createBaseInstallmentLoanPurchase() {
    return {
        paymentId: '',
        merchantName: '',
        merchantLogoUrl: '',
        amount: undefined,
        createdAtMs: '0',
        category: undefined,
    };
}
exports.InstallmentLoanPurchase = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        if (isSet(object.merchantName)) {
            message.merchantName = globalThis.String(object.merchantName);
        }
        if (isSet(object.merchantLogoUrl)) {
            message.merchantLogoUrl = globalThis.String(object.merchantLogoUrl);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        if (isSet(object.category)) {
            message.category = transaction_1.TransactionCategory.fromJSON(object.category);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.merchantName !== undefined && message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.merchantLogoUrl !== undefined && message.merchantLogoUrl !== '') {
            obj.merchantLogoUrl = message.merchantLogoUrl;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.category !== undefined) {
            obj.category = transaction_1.TransactionCategory.toJSON(message.category);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPurchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanPurchase();
        message.paymentId = object.paymentId ?? '';
        message.merchantName = object.merchantName ?? '';
        message.merchantLogoUrl = object.merchantLogoUrl ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.category = (object.category !== undefined && object.category !== null)
            ? transaction_1.TransactionCategory.fromPartial(object.category)
            : undefined;
        return message;
    },
};
function createBaseInstallmentLoanBorrowCash() {
    return { date: date_1.LocalDate.fromPartial({}) };
}
exports.InstallmentLoanBorrowCash = {
    fromJSON(object) {
        const message = {
            date: isSet(object.date) ? date_1.LocalDate.fromJSON(object.date) : date_1.LocalDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.date !== undefined) {
            obj.date = date_1.LocalDate.toJSON(message.date);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanBorrowCash.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanBorrowCash();
        message.date = (object.date !== undefined && object.date !== null)
            ? date_1.LocalDate.fromPartial(object.date)
            : date_1.LocalDate.fromPartial({});
        return message;
    },
};
function createBaseInstallmentLoanInstallment() {
    return {
        id: '',
        principal: amount_1.Amount.fromPartial({}),
        fee: amount_1.Amount.fromPartial({}),
        dueOn: date_1.DateMessage.fromPartial({}),
        pastDueAtMs: '0',
        paidAtMs: '0',
        status: InstallmentLoanStatus.INVALID_INSTALLMENT_LOAN_STATUS,
        amountPaid: undefined,
    };
}
exports.InstallmentLoanInstallment = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            principal: isSet(object.principal)
                ? amount_1.Amount.fromJSON(object.principal)
                : amount_1.Amount.fromPartial({}),
            fee: isSet(object.fee) ? amount_1.Amount.fromJSON(object.fee) : amount_1.Amount.fromPartial({}),
            dueOn: isSet(object.dueOn) ? date_1.DateMessage.fromJSON(object.dueOn) : date_1.DateMessage.fromPartial({}),
            status: isSet(object.status)
                ? installmentLoanStatusFromJSON(object.status)
                : InstallmentLoanStatus.INVALID_INSTALLMENT_LOAN_STATUS,
        };
        if (isSet(object.pastDueAtMs)) {
            message.pastDueAtMs = globalThis.String(object.pastDueAtMs);
        }
        if (isSet(object.paidAtMs)) {
            message.paidAtMs = globalThis.String(object.paidAtMs);
        }
        if (isSet(object.amountPaid)) {
            message.amountPaid = amount_1.Amount.fromJSON(object.amountPaid);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.principal !== undefined) {
            obj.principal = amount_1.Amount.toJSON(message.principal);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.dueOn !== undefined) {
            obj.dueOn = date_1.DateMessage.toJSON(message.dueOn);
        }
        if (message.pastDueAtMs !== undefined && message.pastDueAtMs !== '0') {
            obj.pastDueAtMs = message.pastDueAtMs;
        }
        if (message.paidAtMs !== undefined && message.paidAtMs !== '0') {
            obj.paidAtMs = message.paidAtMs;
        }
        if (message.status !== InstallmentLoanStatus.INVALID_INSTALLMENT_LOAN_STATUS) {
            obj.status = installmentLoanStatusToJSON(message.status);
        }
        if (message.amountPaid !== undefined) {
            obj.amountPaid = amount_1.Amount.toJSON(message.amountPaid);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanInstallment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanInstallment();
        message.id = object.id ?? '';
        message.principal = (object.principal !== undefined && object.principal !== null)
            ? amount_1.Amount.fromPartial(object.principal)
            : amount_1.Amount.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : amount_1.Amount.fromPartial({});
        message.dueOn = (object.dueOn !== undefined && object.dueOn !== null)
            ? date_1.DateMessage.fromPartial(object.dueOn)
            : date_1.DateMessage.fromPartial({});
        message.pastDueAtMs = object.pastDueAtMs ?? '0';
        message.paidAtMs = object.paidAtMs ?? '0';
        message.status = object.status ?? InstallmentLoanStatus.INVALID_INSTALLMENT_LOAN_STATUS;
        message.amountPaid = (object.amountPaid !== undefined && object.amountPaid !== null)
            ? amount_1.Amount.fromPartial(object.amountPaid)
            : undefined;
        return message;
    },
};
function createBaseCryptoAccountOrigin() {
    return { graduation: undefined };
}
exports.CryptoAccountOrigin = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.graduation)) {
            message.graduation = exports.CryptoAccountOriginGraduation.fromJSON(object.graduation);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.graduation !== undefined) {
            obj.graduation = exports.CryptoAccountOriginGraduation.toJSON(message.graduation);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoAccountOrigin.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoAccountOrigin();
        message.graduation = (object.graduation !== undefined && object.graduation !== null)
            ? exports.CryptoAccountOriginGraduation.fromPartial(object.graduation)
            : undefined;
        return message;
    },
};
function createBaseCryptoAccountOriginGraduation() {
    return {
        sponsoredAccountId: '',
        amount: amount_1.Amount.fromPartial({}),
        status: CryptoAccountOriginGraduationGraduationStatus.INVALID_GRADUATION_STATUS,
    };
}
exports.CryptoAccountOriginGraduation = {
    fromJSON(object) {
        const message = {
            sponsoredAccountId: isSet(object.sponsoredAccountId)
                ? globalThis.String(object.sponsoredAccountId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            status: isSet(object.status)
                ? cryptoAccountOriginGraduationGraduationStatusFromJSON(object.status)
                : CryptoAccountOriginGraduationGraduationStatus.INVALID_GRADUATION_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsoredAccountId !== '') {
            obj.sponsoredAccountId = message.sponsoredAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.status !== CryptoAccountOriginGraduationGraduationStatus.INVALID_GRADUATION_STATUS) {
            obj.status = cryptoAccountOriginGraduationGraduationStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoAccountOriginGraduation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoAccountOriginGraduation();
        message.sponsoredAccountId = object.sponsoredAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.status = object.status ??
            CryptoAccountOriginGraduationGraduationStatus.INVALID_GRADUATION_STATUS;
        return message;
    },
};
function createBaseCryptoAccountTransfer() {
    return { graduation: undefined };
}
exports.CryptoAccountTransfer = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.graduation)) {
            message.graduation = exports.CryptoAccountTransferGraduation.fromJSON(object.graduation);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.graduation !== undefined) {
            obj.graduation = exports.CryptoAccountTransferGraduation.toJSON(message.graduation);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoAccountTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoAccountTransfer();
        message.graduation = (object.graduation !== undefined && object.graduation !== null)
            ? exports.CryptoAccountTransferGraduation.fromPartial(object.graduation)
            : undefined;
        return message;
    },
};
function createBaseCryptoAccountTransferGraduation() {
    return { graduatedAccountId: '', graduatedSponseeId: '' };
}
exports.CryptoAccountTransferGraduation = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.graduatedAccountId)) {
            message.graduatedAccountId = globalThis.String(object.graduatedAccountId);
        }
        if (isSet(object.graduatedSponseeId)) {
            message.graduatedSponseeId = globalThis.String(object.graduatedSponseeId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.graduatedAccountId !== undefined && message.graduatedAccountId !== '') {
            obj.graduatedAccountId = message.graduatedAccountId;
        }
        if (message.graduatedSponseeId !== undefined && message.graduatedSponseeId !== '') {
            obj.graduatedSponseeId = message.graduatedSponseeId;
        }
        return obj;
    },
    create(base) {
        return exports.CryptoAccountTransferGraduation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoAccountTransferGraduation();
        message.graduatedAccountId = object.graduatedAccountId ?? '';
        message.graduatedSponseeId = object.graduatedSponseeId ?? '';
        return message;
    },
};
function createBaseCryptoAccountOwnershipChange() {
    return { authorizedUserId: '' };
}
exports.CryptoAccountOwnershipChange = {
    fromJSON(object) {
        const message = {
            authorizedUserId: isSet(object.authorizedUserId)
                ? globalThis.String(object.authorizedUserId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.authorizedUserId !== '') {
            obj.authorizedUserId = message.authorizedUserId;
        }
        return obj;
    },
    create(base) {
        return exports.CryptoAccountOwnershipChange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoAccountOwnershipChange();
        message.authorizedUserId = object.authorizedUserId ?? '';
        return message;
    },
};
function createBaseCrypto() {
    return { origin: undefined, transfer: undefined, ownershipChange: undefined };
}
exports.Crypto = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.origin)) {
            message.origin = exports.CryptoAccountOrigin.fromJSON(object.origin);
        }
        if (isSet(object.transfer)) {
            message.transfer = exports.CryptoAccountTransfer.fromJSON(object.transfer);
        }
        if (isSet(object.ownershipChange)) {
            message.ownershipChange = exports.CryptoAccountOwnershipChange.fromJSON(object.ownershipChange);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.origin !== undefined) {
            obj.origin = exports.CryptoAccountOrigin.toJSON(message.origin);
        }
        if (message.transfer !== undefined) {
            obj.transfer = exports.CryptoAccountTransfer.toJSON(message.transfer);
        }
        if (message.ownershipChange !== undefined) {
            obj.ownershipChange = exports.CryptoAccountOwnershipChange.toJSON(message.ownershipChange);
        }
        return obj;
    },
    create(base) {
        return exports.Crypto.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCrypto();
        message.origin = (object.origin !== undefined && object.origin !== null)
            ? exports.CryptoAccountOrigin.fromPartial(object.origin)
            : undefined;
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? exports.CryptoAccountTransfer.fromPartial(object.transfer)
            : undefined;
        message.ownershipChange =
            (object.ownershipChange !== undefined && object.ownershipChange !== null)
                ? exports.CryptoAccountOwnershipChange.fromPartial(object.ownershipChange)
                : undefined;
        return message;
    },
};
function createBaseAccountPermission() {
    return { userId: undefined, group: undefined, accessLevel: AccountAccessLevel.INVALID };
}
exports.AccountPermission = {
    fromJSON(object) {
        const message = {
            accessLevel: isSet(object.accessLevel)
                ? accountAccessLevelFromJSON(object.accessLevel)
                : AccountAccessLevel.INVALID,
        };
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.group)) {
            message.group = exports.AccountPermissionGroup.fromJSON(object.group);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined) {
            obj.userId = message.userId;
        }
        if (message.group !== undefined) {
            obj.group = exports.AccountPermissionGroup.toJSON(message.group);
        }
        if (message.accessLevel !== AccountAccessLevel.INVALID) {
            obj.accessLevel = accountAccessLevelToJSON(message.accessLevel);
        }
        return obj;
    },
    create(base) {
        return exports.AccountPermission.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountPermission();
        message.userId = object.userId ?? undefined;
        message.group = (object.group !== undefined && object.group !== null)
            ? exports.AccountPermissionGroup.fromPartial(object.group)
            : undefined;
        message.accessLevel = object.accessLevel ?? AccountAccessLevel.INVALID;
        return message;
    },
};
function createBaseAccountPermissionGroup() {
    return { familyId: '', familyGroup: family_group_1.FamilyGroup.FAMILY_INVALID };
}
exports.AccountPermissionGroup = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
            familyGroup: isSet(object.familyGroup)
                ? (0, family_group_1.familyGroupFromJSON)(object.familyGroup)
                : family_group_1.FamilyGroup.FAMILY_INVALID,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        if (message.familyGroup !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.familyGroup = (0, family_group_1.familyGroupToJSON)(message.familyGroup);
        }
        return obj;
    },
    create(base) {
        return exports.AccountPermissionGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountPermissionGroup();
        message.familyId = object.familyId ?? '';
        message.familyGroup = object.familyGroup ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        return message;
    },
};
function unsecuredCreditAutoPayTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_AUTO_PAY_TYPE':
            return UnsecuredCreditAutoPayType.INVALID_AUTO_PAY_TYPE;
        case 1:
        case 'PAY_MINIMUM_BALANCE':
            return UnsecuredCreditAutoPayType.PAY_MINIMUM_BALANCE;
        case 2:
        case 'PAY_STATEMENT_BALANCE':
            return UnsecuredCreditAutoPayType.PAY_STATEMENT_BALANCE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return UnsecuredCreditAutoPayType.UNRECOGNIZED;
    }
}
exports.unsecuredCreditAutoPayTypeFromJSON = unsecuredCreditAutoPayTypeFromJSON;
function unsecuredCreditAutoPayTypeToJSON(object) {
    switch (object) {
        case UnsecuredCreditAutoPayType.INVALID_AUTO_PAY_TYPE:
            return 'INVALID_AUTO_PAY_TYPE';
        case UnsecuredCreditAutoPayType.PAY_MINIMUM_BALANCE:
            return 'PAY_MINIMUM_BALANCE';
        case UnsecuredCreditAutoPayType.PAY_STATEMENT_BALANCE:
            return 'PAY_STATEMENT_BALANCE';
        case UnsecuredCreditAutoPayType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.unsecuredCreditAutoPayTypeToJSON = unsecuredCreditAutoPayTypeToJSON;
function accountAccessLevelFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID':
            return AccountAccessLevel.INVALID;
        case 1:
        case 'RESTRICTED':
            return AccountAccessLevel.RESTRICTED;
        case 10:
        case 'FULL':
            return AccountAccessLevel.FULL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountAccessLevel.UNRECOGNIZED;
    }
}
exports.accountAccessLevelFromJSON = accountAccessLevelFromJSON;
function accountAccessLevelToJSON(object) {
    switch (object) {
        case AccountAccessLevel.INVALID:
            return 'INVALID';
        case AccountAccessLevel.RESTRICTED:
            return 'RESTRICTED';
        case AccountAccessLevel.FULL:
            return 'FULL';
        case AccountAccessLevel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountAccessLevelToJSON = accountAccessLevelToJSON;
function accountClosabilityFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACCOUNT_CLOSABILITY':
            return AccountClosability.INVALID_ACCOUNT_CLOSABILITY;
        case 1:
        case 'CLOSABLE':
            return AccountClosability.CLOSABLE;
        case 2:
        case 'BALANCE_NOT_ZERO':
            return AccountClosability.BALANCE_NOT_ZERO;
        case 3:
        case 'PENDING_TRANSACTION':
            return AccountClosability.PENDING_TRANSACTION;
        case 4:
        case 'PENDING_CARD_AUTH':
            return AccountClosability.PENDING_CARD_AUTH;
        case 5:
        case 'PENDING_TRANSFER_HOLD':
            return AccountClosability.PENDING_TRANSFER_HOLD;
        case 6:
        case 'UNRESOLVED_DISPUTE':
            return AccountClosability.UNRESOLVED_DISPUTE;
        case 7:
        case 'DEPENDENT_ACCOUNT':
            return AccountClosability.DEPENDENT_ACCOUNT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountClosability.UNRECOGNIZED;
    }
}
exports.accountClosabilityFromJSON = accountClosabilityFromJSON;
function accountClosabilityToJSON(object) {
    switch (object) {
        case AccountClosability.INVALID_ACCOUNT_CLOSABILITY:
            return 'INVALID_ACCOUNT_CLOSABILITY';
        case AccountClosability.CLOSABLE:
            return 'CLOSABLE';
        case AccountClosability.BALANCE_NOT_ZERO:
            return 'BALANCE_NOT_ZERO';
        case AccountClosability.PENDING_TRANSACTION:
            return 'PENDING_TRANSACTION';
        case AccountClosability.PENDING_CARD_AUTH:
            return 'PENDING_CARD_AUTH';
        case AccountClosability.PENDING_TRANSFER_HOLD:
            return 'PENDING_TRANSFER_HOLD';
        case AccountClosability.UNRESOLVED_DISPUTE:
            return 'UNRESOLVED_DISPUTE';
        case AccountClosability.DEPENDENT_ACCOUNT:
            return 'DEPENDENT_ACCOUNT';
        case AccountClosability.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountClosabilityToJSON = accountClosabilityToJSON;
function subAccountFilterFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SUB_ACCOUNT_FILTER':
            return SubAccountFilter.INVALID_SUB_ACCOUNT_FILTER;
        case 1:
        case 'ONLY_OPEN':
            return SubAccountFilter.ONLY_OPEN;
        case 2:
        case 'ONLY_CLOSED':
            return SubAccountFilter.ONLY_CLOSED;
        case 3:
        case 'ALL':
            return SubAccountFilter.ALL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SubAccountFilter.UNRECOGNIZED;
    }
}
exports.subAccountFilterFromJSON = subAccountFilterFromJSON;
function subAccountFilterToJSON(object) {
    switch (object) {
        case SubAccountFilter.INVALID_SUB_ACCOUNT_FILTER:
            return 'INVALID_SUB_ACCOUNT_FILTER';
        case SubAccountFilter.ONLY_OPEN:
            return 'ONLY_OPEN';
        case SubAccountFilter.ONLY_CLOSED:
            return 'ONLY_CLOSED';
        case SubAccountFilter.ALL:
            return 'ALL';
        case SubAccountFilter.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.subAccountFilterToJSON = subAccountFilterToJSON;
function accountTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACCOUNT_TYPE':
            return AccountType.INVALID_ACCOUNT_TYPE;
        case 1:
        case 'DEPOSIT':
            return AccountType.DEPOSIT;
        case 2:
        case 'SAVINGS':
            return AccountType.SAVINGS;
        case 3:
        case 'CREDIT':
            return AccountType.CREDIT;
        case 4:
        case 'INSTALLMENT_LOAN':
            return AccountType.INSTALLMENT_LOAN;
        case 5:
        case 'CRYPTO':
            return AccountType.CRYPTO;
        case 6:
        case 'UNSECURED_CREDIT':
            return AccountType.UNSECURED_CREDIT;
        case 8:
        case 'CASH_ADVANCE':
            return AccountType.CASH_ADVANCE;
        case 7:
        case 'POINTS':
            return AccountType.POINTS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AccountType.UNRECOGNIZED;
    }
}
exports.accountTypeFromJSON = accountTypeFromJSON;
function accountTypeToJSON(object) {
    switch (object) {
        case AccountType.INVALID_ACCOUNT_TYPE:
            return 'INVALID_ACCOUNT_TYPE';
        case AccountType.DEPOSIT:
            return 'DEPOSIT';
        case AccountType.SAVINGS:
            return 'SAVINGS';
        case AccountType.CREDIT:
            return 'CREDIT';
        case AccountType.INSTALLMENT_LOAN:
            return 'INSTALLMENT_LOAN';
        case AccountType.CRYPTO:
            return 'CRYPTO';
        case AccountType.UNSECURED_CREDIT:
            return 'UNSECURED_CREDIT';
        case AccountType.CASH_ADVANCE:
            return 'CASH_ADVANCE';
        case AccountType.POINTS:
            return 'POINTS';
        case AccountType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.accountTypeToJSON = accountTypeToJSON;
function installmentLoanPaymentScheduleFromJSON(object) {
    switch (object) {
        case 0:
        case 'SCHEDULE_NOT_SET':
            return InstallmentLoanPaymentSchedule.SCHEDULE_NOT_SET;
        case 1:
        case 'BI_WEEKLY':
            return InstallmentLoanPaymentSchedule.BI_WEEKLY;
        case 2:
        case 'ESTIMATED':
            return InstallmentLoanPaymentSchedule.ESTIMATED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstallmentLoanPaymentSchedule.UNRECOGNIZED;
    }
}
exports.installmentLoanPaymentScheduleFromJSON = installmentLoanPaymentScheduleFromJSON;
function installmentLoanPaymentScheduleToJSON(object) {
    switch (object) {
        case InstallmentLoanPaymentSchedule.SCHEDULE_NOT_SET:
            return 'SCHEDULE_NOT_SET';
        case InstallmentLoanPaymentSchedule.BI_WEEKLY:
            return 'BI_WEEKLY';
        case InstallmentLoanPaymentSchedule.ESTIMATED:
            return 'ESTIMATED';
        case InstallmentLoanPaymentSchedule.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.installmentLoanPaymentScheduleToJSON = installmentLoanPaymentScheduleToJSON;
function installmentLoanStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INSTALLMENT_LOAN_STATUS':
            return InstallmentLoanStatus.INVALID_INSTALLMENT_LOAN_STATUS;
        case 1:
        case 'PENDING':
            return InstallmentLoanStatus.PENDING;
        case 2:
        case 'PAID':
            return InstallmentLoanStatus.PAID;
        case 3:
        case 'DUE':
            return InstallmentLoanStatus.DUE;
        case 4:
        case 'PAST_DUE':
            return InstallmentLoanStatus.PAST_DUE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InstallmentLoanStatus.UNRECOGNIZED;
    }
}
exports.installmentLoanStatusFromJSON = installmentLoanStatusFromJSON;
function installmentLoanStatusToJSON(object) {
    switch (object) {
        case InstallmentLoanStatus.INVALID_INSTALLMENT_LOAN_STATUS:
            return 'INVALID_INSTALLMENT_LOAN_STATUS';
        case InstallmentLoanStatus.PENDING:
            return 'PENDING';
        case InstallmentLoanStatus.PAID:
            return 'PAID';
        case InstallmentLoanStatus.DUE:
            return 'DUE';
        case InstallmentLoanStatus.PAST_DUE:
            return 'PAST_DUE';
        case InstallmentLoanStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.installmentLoanStatusToJSON = installmentLoanStatusToJSON;
function cryptoAccountOriginGraduationGraduationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_GRADUATION_STATUS':
            return CryptoAccountOriginGraduationGraduationStatus.INVALID_GRADUATION_STATUS;
        case 1:
        case 'PENDING':
            return CryptoAccountOriginGraduationGraduationStatus.PENDING;
        case 2:
        case 'COMPLETED':
            return CryptoAccountOriginGraduationGraduationStatus.COMPLETED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CryptoAccountOriginGraduationGraduationStatus.UNRECOGNIZED;
    }
}
exports.cryptoAccountOriginGraduationGraduationStatusFromJSON = cryptoAccountOriginGraduationGraduationStatusFromJSON;
function cryptoAccountOriginGraduationGraduationStatusToJSON(object) {
    switch (object) {
        case CryptoAccountOriginGraduationGraduationStatus.INVALID_GRADUATION_STATUS:
            return 'INVALID_GRADUATION_STATUS';
        case CryptoAccountOriginGraduationGraduationStatus.PENDING:
            return 'PENDING';
        case CryptoAccountOriginGraduationGraduationStatus.COMPLETED:
            return 'COMPLETED';
        case CryptoAccountOriginGraduationGraduationStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cryptoAccountOriginGraduationGraduationStatusToJSON = cryptoAccountOriginGraduationGraduationStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account.js.map